module.exports = __webpack_public_path__ + "0b3c59c68efd10f4d1c209956984e8fb.png";